module.exports = __webpack_public_path__ + "img/hero-section-api.5ba18f70.svg";